import Vue from 'vue'

import KurenotoriLp1 from './Kurenotori/Lp1/KurenotoriLp1'
import HouenLp1 from './Houen/Lp1/HoueniLp1'

export default {
  install(Vue, options) {
    Vue.component('mark-kurenotori-lp1', KurenotoriLp1)
    Vue.component('mark-houen-lp1', HouenLp1)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/MarkLp/index.js